<form [formGroup]="form" class="space-y-4 mt-2" (ngSubmit)="save()">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <p-float-label variant="on">
      <input pInputText formControlName="firstName" id="firstName" class="w-full" />
      <label for="firstName">Nome *</label>
    </p-float-label>
    <p-float-label variant="on">
      <input pInputText formControlName="lastName" id="lastName" class="w-full" />
      <label for="lastName">Cognome *</label>
    </p-float-label>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <p-float-label variant="on">
      <input pInputText formControlName="email" id="email" class="w-full" type="email" />
      <label for="email">Email</label>
    </p-float-label>
    <p-floatlabel variant="on" class="w-full">
      <p-select
        inputId="companyId"
        formControlName="companyId"
        [options]="companies"
        optionLabel="name"
        optionValue="id"
        [showClear]="true"
        placeholder="Seleziona Azienda"
        class="w-full"
        appendTo="body"
      />
      <label for="companyId">Azienda</label>
    </p-floatlabel>
  </div>

  <p-multiselect
    formControlName="userIds"
    [options]="users"
    optionLabel="email"
    optionValue="id"
    placeholder="Associa Operatori"
    class="w-full"
    display="chip"
    appendTo="body"
  />

  <p-multiselect
    formControlName="teamIds"
    [options]="teamOptions"
    optionLabel="name"
    optionValue="id"
    placeholder="Associa Team"
    class="w-full"
    display="chip"
    appendTo="body"
  >
    <ng-template #item let-team>
      <span>{{ team.name }}</span>
      <span class="text-muted-color text-xs ml-1">· {{ team.membersCount ?? 0 }} membri</span>
    </ng-template>
  </p-multiselect>

  <p-divider />

  <div class="flex items-center justify-between">
    <span class="font-medium">Numeri di Telefono</span>
    <p-button
      icon="pi pi-plus"
      label="Aggiungi"
      size="small"
      severity="secondary"
      [outlined]="true"
      type="button"
      (click)="addPhone()"
    />
  </div>

  <div formArrayName="phoneNumbers" class="space-y-3">
    @for (phone of phoneNumbers.controls; track $index) {
      <div [formGroupName]="$index" class="flex items-start gap-2">
        <p-select
          formControlName="prefix"
          [options]="phonePrefixes"
          optionLabel="label"
          optionValue="value"
          class="flex-shrink-0"
          styleClass="w-40"
        />
        <div class="flex-1 flex flex-col gap-1">
          <p-float-label variant="on" class="w-full">
            <input
              pInputText
              formControlName="localNumber"
              [id]="'localNumber_' + $index"
              class="w-full"
              [class.ng-invalid]="phoneErrors[$index]"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="off"
            />
            <label [for]="'localNumber_' + $index">Numero</label>
          </p-float-label>
          @if (phoneErrors[$index]) {
            <small class="text-red-500 text-xs">{{ phoneErrors[$index] }}</small>
          }
        </div>
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [outlined]="true"
          [rounded]="true"
          size="small"
          type="button"
          (click)="removePhone($index)"
        />
      </div>
    }
  </div>

  <div class="flex justify-end gap-2 pt-2">
    <p-button
      label="Cancella"
      icon="pi pi-times-circle"
      size="small"
      severity="secondary"
      type="button"
      (click)="closeDialog()"
    />
    <p-button
      label="Salva"
      icon="pi pi-check-circle"
      size="small"
      type="submit"
      [disabled]="form.invalid || saving"
      [loading]="saving"
    />
  </div>
</form>
